<template>
  <el-dialog
    title="Relatórios Financeiros - Aluguel"
    @open="onOpen"
    :visible.sync="visibility"
    :before-close="fechar"
    append-to-body
    :close-on-click-modal="false"
    width="40%"
    v-loading="loading"
  >
    <el-form :model="relatorio" ref="form" size="small" label-position="top" hide-required-asterisk :show-message="false"  :rules="validacao" style="margin-top: -30px;">
      <el-row :gutter="20">
        <el-col :span="18">
          <el-form-item label="Relatório" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              @change="limparFiltros"
              clearable 
              placeholder=""
              style="width: 100%;">
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label=" ">
            <el-radio-group v-model="relatorio.xls">
              <el-radio :label="false">PDF</el-radio><br/>
              <el-radio :label="true">Excel</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10" v-if="exibirDataBaixaRepasse" style="margin-top: 10px">
        <el-col :span="18" :md="24">
          <el-form-item label="Pesquisar por:" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.dataBaixaRepasse" style="font-size: small;" class="filtros-radio">

              <el-radio
                label="DATA_PAGAMENTO"
                class="field-margin"
              >
                Data de Pagamento
              </el-radio>
              
              <el-radio
                label="DATA_BAIXA"
                class="field-margin"
              >
                Data da Baixa
              </el-radio>

              <el-radio
                v-if="exibirDataRepasse"
                label="DATA_REPASSE"
                class="field-margin"
              >
                Data de Repasse
              </el-radio>
      
              <el-radio
                v-if="exibirDataCredito"
                label="DATA_CREDITO"
                class="field-margin"
              >
                Data de Crédito
              </el-radio>
              
              <el-radio
                v-if="exibirDataVencimento"
                label="DATA_VENCIMENTO"
                class="field-margin"
              >
                Data de Vencimento
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="14" v-if="exibirDiaVencimento">
        <el-col :span="8">
          <el-form-item label="Dia do Vencimento" prop="diaVencimento" style="width: 100%;font-weight: bold;">
            <el-input v-model="relatorio.diaVencimento" v-mask="'##'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

       <el-row :gutter="14" v-if="exibirPeriodo" style="margin-top: 5px">
        <el-col :span="12">
          <el-form-item label="Data Inicial" prop="dataInicial" style="width: 100%;font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Data Final" prop="dataFinal" style="width: 100%;font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirTipoBaixa" style="margin-top: 10px">
        <el-col :span="16" :md="24">
          <el-form-item label="Tipos de Baixas" style="width: 100%;font-weight: bold;">
            <el-radio-group class="field-margin" v-model="relatorio.tipoBaixa" style="font-size: small;">
              <el-radio label="TODOS" >Todas</el-radio>
              <el-radio label="AUTOMATICA">Automáticas</el-radio>
              <el-radio label="MANUAL" >Manuais</el-radio><br/>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirDeclaracaoIR" style="margin-top: 10px">
        <el-col :span="16" :md="24">
          <el-form-item label="Declaração do IR" style="width: 100%;font-weight: bold;">
            <el-radio-group class="field-margin" v-model="relatorio.declaracaoIR" style="font-size: small;">
              <el-radio label="TODOS" >Todos</el-radio>
              <el-radio label="DECLARAR_IR" >Declarar IR</el-radio>
              <el-radio label="NAO_DECLARAR_IR" >Não Declarar IR</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirBoletosAvulsos">
        <el-col :span="12" >
          <el-form-item label="Status" style="width: 100%">
            <el-select v-model="relatorio.statusBoletoAvulso" size="small">
              <el-option value="TODOS" label="Todos" />
              <el-option value="ATRASADOS" label="Atrasados" />
              <el-option value="A_VENCER" label="A Vencer" />
              <el-option value="PAGOS" label="Pagos" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Tipo de Boleto" style="width: 100%">
            <el-select v-model="relatorio.tipoBoleto" size="small" placeholder clearable @clear="relatorio.tipoBoleto = 'TODOS' ">
              <el-option
                v-for="item in tipoBoleto"
                :key="item.id"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFormasPagamento" style="margin-top: 10px">
        <el-col :span="16" :md="24">
          <el-form-item label="Forma de Pagamento" style="width: 100%;font-weight: bold;">
            <el-radio-group class="field-margin" v-model="relatorio.formaPagamentoRepasse" style="font-size: small;">
              <el-radio label="TODOS" >Todos</el-radio>
              <el-radio label="RECEBIMENTO_IMOBILIARIA" >Pago na Imobiliária</el-radio>
              <el-radio label="DEPOSITO_EM_CONTA" >Depósito em Conta</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      

      <el-row :gutter="10"  v-if="exibirMaisFiltros">
        <el-col :span="24" :md="24">
          <div style="margin-left: 35%;">
            <el-button type="text" @click="expandirFiltros" class="expand-button">
            <span>{{this.maisFiltros ? 'Menos Filtros' : 'Mais Filtros'}}</span>
            <span class="arrow el-icon-caret-bottom" :class="{'rotated': maisFiltros}"></span>
          </el-button>
          </div>
        </el-col>
      </el-row>

      <el-collapse-transition name="transition2">
        <div v-show="exibirStatusTipoAluguel">
          <el-row :gutter="24" >
            <el-col :span="12" :md="12" class="section-vertical">
              <el-form-item label="Filtrar por Contratos" style="width: 100%;font-weight: bold;">
                <el-checkbox-group v-model="relatorio.statusSelecionados" class="field-margin">
                  <el-checkbox label="APROVADO">Aprovados</el-checkbox>
                  <el-checkbox label="FINALIZADO">Finalizados</el-checkbox>
                  <el-checkbox label="JURIDICO">No Jurídico</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="10" :md="10">
              <el-form-item label="Tipo de Aluguel" style="width: 100%;font-weight: bold;">
                <el-radio-group v-model="relatorio.tipoAluguel" style="font-size: small;" class="field-margin">
                  <el-radio label="TODOS" >Todos</el-radio>
                  <el-radio label="GARANTIDO" class="field-margin">Garantidos</el-radio>
                  <el-radio label="NAO_GARANTIDO" class="field-margin">Não Garantidos</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>    

      <el-collapse-transition name="transition3">
        <div v-show="exibirEdificioCondominio">
          <el-row :gutter="10" class="expand-section" style="margin-top: 5px">
            <el-col :span="16" :md="24">
              <el-form-item label="Condomínio" style="width: 100%;font-weight: bold;">
                <el-radio-group v-model="relatorio.filtroCondominio" style="font-size: small;">
                  <el-radio :label="false" >Todos</el-radio>
                  <el-radio :label="true" >Selecionar Condomínio</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>            
        </div>      
      </el-collapse-transition> 
      <el-row :gutter="10" v-show="relatorio.filtroCondominio">
        <el-col :span="16" :md="24">
          <el-form-item label="" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.condominio"
              :remote-method="recuperarCondominiosSelect"
              :loading="loadingCondominios"
              value-key="id"
              placeholder="Digite o nome do Condomínio"
              loading-text="Carregando Condomínios"
              no-data-text="Nenhum Condomínio encontrado"
              filterable
              clearable
              @clear="relatorio.condominio = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in condominiosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>   
      <el-collapse-transition name="transition4">
        <div v-show="exibirFiltroContratos">
          <el-row :gutter="10" class="expand-section" style="margin-top: 5px">
            <el-col :span="16" :md="24">
              <el-form-item label="Contrato" style="width: 100%;font-weight: bold;">
                <el-radio-group v-model="relatorio.filtroContrato" style="font-size: small;">
                  <el-radio :label="false" >Todos</el-radio>
                  <el-radio :label="true" >Selecionar Contrato</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>  
      </el-collapse-transition>

      <el-row :gutter="2" v-if="relatorio.filtroContrato" style="width: 100%;font-weight: bold;">
        <el-col :span="24">
          <el-form-item label="">
            <el-select
              v-model="relatorio.aluguel"
              :remote-method="recuperarContratosSelect"
              :loading="loadingContratos"
              value-key="id"
              placeholder="Digite o Contrato"
              loading-text="Carregando Contratos"
              no-data-text="Nenhum contrato encontrado"
              filterable
              clearable
              @clear="relatorio.aluguel = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in listaContratos"
                :key="item.id"
                :label="`${item.idNaImobiliaria} - ${item.imovel.endereco} (${item.imovel.bairro.nome})`"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
          
      <el-row :gutter="14" v-if="exibirDataRemessa">
        <el-col :span="8">
          <el-form-item label="Data Remessa" prop="dataRemessa" style="width: 100%;font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-collapse-transition name="transition1">
        <div v-show="exibirBancos">
          <el-row :gutter="10" class="expand-section" style="margin-top: 5px">
            <el-col :span="16" :md="24">
              <el-form-item label="Banco da Imobiliária" style="width: 100%;font-weight: bold;">
                <el-radio-group v-model="relatorio.filtroBanco" style="font-size: small;">
                  <el-radio :label="false" >Todos</el-radio>
                  <el-radio :label="true" >Selecionar Banco</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>  
      </el-collapse-transition>
      <el-row :gutter="10" v-if="relatorio.filtroBanco">
        <el-col :span="24">
            <el-form-item label="" prop="" style="width: 100%;font-weight: bold;">
              <el-select 
                v-model="relatorio.bancoRepasse" 
                value-key="data" 
                placeholder="Selecione o Banco" 
                filterable 
                clearable
                @clear="relatorio.bancoRepasse = undefined" 
                default-first-option 
                style="width: 100%">
                <el-option v-for="item in bancos" :key="item.data" :label="item.label" :value="item.data"/>
              </el-select>
            </el-form-item>
        </el-col>
      </el-row>
      
      <el-collapse-transition name="transition5">
        <div v-show="exibirContaImobiliaria">
          <el-row :gutter="10" class="expand-section" style="margin-top: 5px">
            <el-col :span="16" :md="24">
              <el-form-item label="Conta da Imobiliária" style="width: 100%;font-weight: bold;">
                <el-radio-group v-model="relatorio.filtroConta" style="font-size: small;">
                  <el-radio :label="false" >Todas</el-radio>
                  <el-radio :label="true" >Selecionar Conta</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>
      <el-row :gutter="10" v-if="relatorio.filtroConta">
        <el-col :span="15">
          <el-form-item label="" style="width: 100%;font-weight: bold;" prop="contaImobiliaria">
            <el-input 
            v-model="relatorio.contaBancaria.nome" 
            @click.native="exibirSelecionarContaImobiliariaDialog()" 
            readonly 
            placeholder="Clique para selecionar Conta" 
            class="selecionar-conta"><template #suffix><i class="el-icon-search"></i></template></el-input>
          </el-form-item>
        </el-col>
        <!--
        <el-col :span="5">
          <el-form-item label="">
            <el-button @click="exibirSelecionarContaImobiliariaDialog()" type="primary" size="small" round class="btn-box-shadow">Selecionar</el-button>
          </el-form-item>
        </el-col>
        -->
        <el-col  :span="2">
          <el-form-item label="" >
            <el-button @click="relatorio.contaBancaria = {}" type="danger" size="small" circle class="btn-box-shadow"> <i class="el-icon-close"></i> </el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-collapse-transition name="transition6">
        <div v-show="exibirFiltroProprietario">
          <el-row :gutter="10" class="expand-section" style="margin-top: 5px">
            <el-col :span="16" :md="24">
              <el-form-item label="Proprietário" style="width: 100%;font-weight: bold;">
                <el-radio-group v-model="relatorio.filtroProprietario" style="font-size: small;">
                  <el-radio :label="false" >Todos</el-radio>
                  <el-radio :label="true" >Selecionar Proprietário</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>  

      <el-row :gutter="20" v-if="relatorio.filtroProprietario">
        <el-col :span="24">
          <el-form-item label="" style="width: 100%; font-weght: bold;">
            <el-select
              v-model="relatorio.proprietario"
              :remote-method="filtrarProprietariosSelect"
              :loading="loadingProprietario"
              value-key="id"
              placeholder="Digite o Nome ou Id do Proprietário"
              loading-text="Carregando Proprietários"
              no-data-text=""
              filterable
              clearable
              @clear="relatorio.proprietario = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in proprietariosDisponiveis"
                :key="item.id"
                :label="`(${item.idNaImobiliaria})${item.nome}`"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFiltroCliente" class="expand-section" style="margin-top: 5px">
        <el-col :span="16" :md="24">
          <el-form-item :label="'Cliente'" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.filtroCliente" style="font-size: small;">
              <el-radio :label="false" class="field-margin">Todos</el-radio>
              <el-radio :label="true" class="field-margin">Selecionar Cliente</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="relatorio.filtroCliente">
        <el-col :span="24">
          <el-form-item label="" style="width: 100%;font-weight: bold;">
              <el-select v-model="relatorio.cliente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder="Digite o Nome ou Id do Cliente"
              loading-text="Carregando Clientes"
              no-data-text="Nenhum Cliente Encontrado"
              filterable
              clearable
              @clear="relatorio.cliente = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                  v-for="item in clientesDisponiveis"
                  :key="item.id"
                  :label="formatarSelectCliente(item)"
                  :value="item">
              </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-collapse-transition name="transition7">
        <div v-show="exibirFiltroLocatario">
          <el-row :gutter="10" v-if="exibirFiltroLocatario" class="expand-section" style="margin-top: 5px">
            <el-col :span="16" :md="24">
              <el-form-item label="Locatário" style="width: 100%;font-weight: bold;">
                <el-radio-group v-model="relatorio.filtroLocatario" style="font-size: small;">
                  <el-radio :label="false" >Todos</el-radio>
                  <el-radio :label="true" >Selecionar Locatário</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>  
      <el-row :gutter="20" v-if="relatorio.filtroLocatario">
        <el-col :span="24">
          <el-form-item label="" style="width: 100%;font-weight: bold;">
              <el-select v-model="relatorio.cliente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder="Digite o Nome ou Id do Locatário"
              loading-text="Carregando Clientes"
              no-data-text="Nenhum Cliente Encontrado"
              filterable
              clearable
              @clear="relatorio.cliente = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                  v-for="item in clientesDisponiveis"
                  :key="item.id"
                  :label="formatarSelectCliente(item)"
                  :value="item">
              </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirAtendente" class="expand-section" style="margin-top: 5px">
        <el-col :span="16" :md="24">
          <el-form-item label="Atendente" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.filtroAtendente" style="font-size: small;">
              <el-radio :label="false" >Todos</el-radio>
              <el-radio :label="true" >Selecionar Atendente</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="relatorio.filtroAtendente">
        <el-col :span="20">
          <el-form-item label="" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder="Digite o Nome ou Id do Atendente"
              loading-text="Carregando Usuários"
              no-data-text="Nenhum Usuário Encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirTipoContrato && isGestaoColigados">
        <el-col :span="24" >
          <el-form-item label="Tipo de Contrato" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.tipoContrato" label="Tipo" style="font-size: small;">
              <el-radio :label="undefined" style="margin-top:5px">Todos</el-radio>
              <el-radio label="COLIGADO" style="margin-top:5px">Coligados ao Grupo</el-radio>
              <el-radio label="NAO_COLIGADO" style="margin-top:5px">Não Coligados</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirOrdenacao">
        <el-col :span="16" :md="24">
          <el-form-item label="Ordenação:" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.ordenacao" label="Tipo" style="font-size: small;" class="field-margin filtros-radio">
              <el-radio label="CLIENTE" >Nome do Cliente</el-radio>
              <el-radio label="DATA_VENCIMENTO">Data de Vencimento</el-radio>
              <el-radio v-if="exibirItemOrdenacao" label="DATA_PAGAMENTO">Data de Pagamento</el-radio>
              <el-radio v-if="exibirItemOrdenacao" label="DATA_CREDITO">Data do Crédito</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- CHECKBOX ITEMS -->
      <div style="margin-top: 25px" v-if="exibirBotaoVisualizarItensFinanceiros || exibirRepassesAtrasados || exibirPagamentosParciais || exibirInformacoesFiador">
        <el-row :gutter="10" v-if="exibirBotaoVisualizarItensFinanceiros" style="margin-top: 5px; margin-bottom: 5px;">
          <el-col :span="24">
            <el-checkbox
            style="color: #1D1E1F"
            label="Visualizar Itens Financeiros"
            v-model="relatorio.itensFinanceiros">
            </el-checkbox>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="relatorio.itensFinanceiros" style="margin-top: 10px; margin-left: 5px;">
          <el-col :span="24">
            <el-checkbox
            style="color: #1D1E1F"
            label="Exibir Somente Pagos"
            v-model="relatorio.itensPagos">
            </el-checkbox>
          </el-col>
        </el-row>
        
    
        <el-row v-if="exibirRepassesAtrasados" style="margin-bottom: 5px">
          <el-col>
            <el-checkbox v-model="relatorio.exibirRepassesAtrasados">Exibir repasses atrasados</el-checkbox>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-if="exibirPagamentosParciais" style="margin-top: 5px; margin-bottom: 5px;">
          <el-col :span="24">
            <el-checkbox
            style="color: #1D1E1F"
            label="Exibir Somente Pagamentos Parciais"
            v-model="relatorio.exibirPagamentosParciais">
            </el-checkbox>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-if="exibirInformacoesFiador" style="margin-top: 5px; margin-bottom: 5px;">
          <el-col :span="24">
            <el-checkbox
            style="color: #1D1E1F"
            label="Exibir informações do Fiador"
            v-model="relatorio.exibirFiadores">
            </el-checkbox>
          </el-col>
        </el-row>
      </div>
  
    </el-form>
    
    <span slot="footer" style="display: flex; justify-content: space-between;" v-if="this.relatorio.nome">
      <el-button type="warning" size="small" @click="limparFiltros" round class="btn-box-shadow">Limpar Filtros</el-button>
      <el-button type="primary" size="small" @click="gerarRelatorioHandler" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>

    <app-selecionar-conta-bancaria-dialog
      @close="fecharSelecionarContaImobiliariaDialog"
      :visibility="visibilidadeSelecionarContaImobiliariaDialog"
      todosOsBancos
    />
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import funcoes from '../../../util/funcoes.js';
import { BANCOS, TIPO_BOLETO } from '../../../util/constantes.js';
import AppSelecionarContaBancariaDialog from "../../../shared/dialogs/SelecionarContaBancariaDialog.vue";

export default {
  props: {
    visibility: Boolean
  },
  components: {
    AppSelecionarContaBancariaDialog
  },
  data() {
    return {
      validacao: {
        dataInicial: [{ required: true }],
        dataFinal: [{ required: true }]
      },
      relatorio: {
        nome: undefined,
        cliente: undefined,
        locatario: undefined,
        proprietario: undefined,
        usuario: undefined,
        exibirPagamentosParciais: false,
        contaBancaria: { nome: undefined },
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        formaPagamentoRepasse: 'TODOS',
        tipoAluguel: 'TODOS',
        tipoBaixa: 'TODOS',
        filtroCliente:  false,
        filtroProprietario: false,
        filtroContrato: false,
        filtroBanco: false,
        filtroLocatario: false,
        filtroConta: false,
        filtroCondominio: false,
        filtroAtendente: false,
        dataBaixaRepasse: 'DATA_PAGAMENTO',
        declaracaoIR: 'TODOS',
        statusBoletoAvulso: 'TODOS',
        statusSelecionados: ['APROVADO'],
        ordenacao: 'CLIENTE',

        tipoBoleto: 'TODOS',

        xls: false,
        itensFinanceiros: false,
        itensPagos: false

      },

      tiposRelatorios: [],
      maisFiltros: false,

      loadingClientes: false,
      loadingUsuarios: false,
      loadingCondominios: false,
      loadingProprietario: false,
      loadingContratos: false,

      visibilidadeSelecionarContaImobiliariaDialog: false,

      condominiosDisponiveis: [],
      listaContratos: []
    }
  },
  created() {
    if(this.permissoes && this.permissoes.relatorioPrevisaoRepasses){ this.tiposRelatorios.push({label: "Previsão de Repasses", value: "PREVISAO_REPASSE"}) }
    if(this.permissoes && this.permissoes.relatorioPrevisaoRecebimentos){ this.tiposRelatorios.push({label: "Previsão de Recebimentos", value: "PREVISAO_RECEBIMENTO"}) }
    if(this.permissoes && this.permissoes.relatorioRepassesRealizados){ this.tiposRelatorios.push({label: "Repasses Realizados", value: "REPASSES_REALIZADOS"}) }
    if(this.permissoes && this.permissoes.relatorioRepassesAtrasados){ this.tiposRelatorios.push({label: "Repasses Atrasados", value: "REPASSES_ATRASADOS"}) }
    if(this.permissoes && this.permissoes.relatorioRepassesEfetivadosPeriodo){ this.tiposRelatorios.push({label: "Repasses Efetivados por Período", value: "REPASSES_EFETIVADOS_POR_PERIODO"}) }
    if(this.permissoes && this.permissoes.relatorioPrevisaoRecebimentos){ this.tiposRelatorios.push({label: "Resumo Financeiro de Repasses", value: "RESUMO_FINANCEIRO_REPASSE"}) }
    if(this.permissoes && this.permissoes.relatorioAlugueisRecebidos){ this.tiposRelatorios.push({label: "Aluguéis Recebidos", value: "ALUGUEIS_RECEBIDOS"}) }
    if(this.permissoes && this.permissoes.relatorioAlugueisRecebidosComEncargos){ this.tiposRelatorios.push({label: "Aluguéis Recebidos com Encargos", value: "ALUGUEIS_RECEBIDOS_ENCARGOS"}) }
    if(this.permissoes && this.permissoes.relatorioAlugueisAtrasados){ this.tiposRelatorios.push({label: "Aluguéis Atrasados", value: "ALUGUEIS_ATRASADOS"}) }
    if(this.permissoes && this.permissoes.relatorioPrevisaoRecebimentos){ this.tiposRelatorios.push({label: "Resumo Financeiro de Alugueis", value: "RESUMO_FINANCEIRO_RECIBO"}) }
    if(this.permissoes && this.permissoes.relatorioBoletosAvulsos){ this.tiposRelatorios.push({label: "Boletos Avulsos", value: "BOLETOS_AVULSOS"}) }
    if(this.permissoes && this.permissoes.relatorioRemessasGeradas){ this.tiposRelatorios.push({label: "Remessas Geradas", value: "REMESSAS_GERADAS"}) }
    if(this.permissoes && this.permissoes.relatorioDesempenhoLocacao){ this.tiposRelatorios.push({label: "Desempenho de Locação", value: "DESEMPENHO_LOCACAO"}) }
    if(this.permissoes && this.permissoes.relatorioResumoCarteira){ this.tiposRelatorios.push({label: "Resumo da Carteira", value: "RESUMO_CARTEIRA"}) }
    if(this.permissoes && this.permissoes.relatorioRecibosRegistrados){ this.tiposRelatorios.push({label: "Recibos Registrados", value: "RECIBOS_REGISTRADOS"}) }
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "RELATORIOS_FINANCEIROS_ALUGUEL" })[0] },
      isGestaoColigados(state){return state.usuarioLogado.imobiliaria.parametros.gestaoContratosColigados}
    }),
    ...mapState('alugueisRelatoriosStore', {
      usuariosDisponiveis(state) { return state.usuariosDisponiveis },
      clientesDisponiveis(state) { return state.clientesDisponiveis },
      proprietariosDisponiveis(state) { return state.proprietariosDisponiveis }
    }),      
    loading() {
      return this.$store.state.loading;
    },

    labelClienteLocatarioProprietario(){
      return this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' || this.relatorio.nome === 'ALUGUEIS_ATRASADOS' ||
      this.relatorio.nome === 'PREVISAO_RECEBIMENTO' || this.relatorio.nome === 'RESUMO_FINANCEIRO_RECIBO' ? 'Locatário' : 
      this.relatorio.nome === 'RESUMO_FINANCEIRO_REPASSE' || 
      this.relatorio.nome === 'REPASSES_ATRASADOS' ? 'Proprietário' : 'Cliente'
    },

    // VISIBILIDADE CAMPOS
    exibirMaisFiltros(){
      return this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' || this.relatorio.nome === 'ALUGUEIS_ATRASADOS'
    },
    exibirTipoContrato(){
      return this.relatorio.nome && (
        this.relatorio.nome != 'REPASSES_EFETIVADOS_POR_PERIODO'
      )
    },
    exibirEdificioCondominio() {
      return (
        (this.relatorio.nome === 'ALUGUEIS_ATRASADOS' && this.maisFiltros) ||
        (this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' && this.maisFiltros) ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS' || 
        this.relatorio.nome === 'PREVISAO_RECEBIMENTO'
        )
    },
    exibirDataBaixaRepasse() {
      return (
        this.relatorio.nome === 'REPASSES_REALIZADOS' ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS'
        )
    },
    exibirCategoriaCliente(){
      return (false)
    },
    exibirDataRepasse() {
      return !(
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS'||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS'
        )
    },
    exibirDataCredito() {
      return !(
        this.relatorio.nome === 'REPASSES_REALIZADOS'
        )
    },
    exibirDataVencimento() {
      return !(
        this.relatorio.nome === 'REPASSES_REALIZADOS'
        )
    },
    exibirTipoBaixa() {
      return (
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS'
        )
    },
    exibirPeriodo() {
      return (
        this.relatorio.nome === 'ALUGUEIS_ATRASADOS' ||
        this.relatorio.nome === 'BOLETOS_AVULSOS' ||
        this.relatorio.nome === 'PREVISAO_REPASSE' ||
        this.relatorio.nome === 'PREVISAO_RECEBIMENTO' ||
        this.relatorio.nome === 'RESUMO_CARTEIRA' ||
        this.relatorio.nome === 'REPASSES_REALIZADOS' ||
        this.relatorio.nome === 'REPASSES_EFETIVADOS_POR_PERIODO' ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS' ||
        this.relatorio.nome === 'DESEMPENHO_LOCACAO' ||
        this.relatorio.nome === 'RESUMO_FINANCEIRO_REPASSE' ||
        this.relatorio.nome === 'RESUMO_FINANCEIRO_RECIBO' ||
        this.relatorio.nome === 'RECIBOS_REGISTRADOS'
        )
    },
    exibirDataRemessa() {
      return (
        this.relatorio.nome === 'REMESSAS_GERADAS'
        )
    },
    exibirBoletosAvulsos() {
      return (
        this.relatorio.nome === 'BOLETOS_AVULSOS'
        )
    },
    exibirDiaVencimento() {
      return (
        this.relatorio.nome === 'ALUGUEIS_ATRASADOS'
        )
    },
    exibirRepassesAtrasados() {
      return (
        this.relatorio.nome === 'PREVISAO_REPASSE'
        )
    },
    exibirFormasPagamento() {
      return (
        this.relatorio.nome === 'REPASSES_REALIZADOS'
        )
    },
    exibirBancos() {
      return (
        this.relatorio.nome === 'PREVISAO_REPASSE' ||
        this.relatorio.nome === 'REPASSES_ATRASADOS' ||
        (this.relatorio.nome == 'ALUGUEIS_ATRASADOS' && this.maisFiltros)
        )
    },
    exibirFiltroCliente() {
      return this.relatorio.nome === 'BOLETOS_AVULSOS'
    },
    exibirFiltroLocatario(){
      return (this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' && this.maisFiltros) || this.relatorio.nome === 'PREVISAO_RECEBIMENTO' ||
      (this.relatorio.nome === 'ALUGUEIS_ATRASADOS' && this.maisFiltros) || this.relatorio.nome === 'RESUMO_FINANCEIRO_RECIBO'
    },

    exibirFiltroProprietario() {
      return (
        this.relatorio.nome === 'PREVISAO_RECEBIMENTO' || this.relatorio.nome === 'PREVISAO_REPASSE' || 
        this.relatorio.nome === 'REPASSES_REALIZADOS' || this.relatorio.nome === 'REPASSES_ATRASADOS' || 
        this.relatorio.nome === 'REPASSES_EFETIVADOS_POR_PERIODO' || this.relatorio.nome === 'RESUMO_FINANCEIRO_RECIBO' ||
        this.relatorio.nome === 'RESUMO_FINANCEIRO_REPASSE' || (this.relatorio.nome === 'ALUGUEIS_ATRASADOS' && this.maisFiltros) ||
        (this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' && this.maisFiltros)
      );
    },
    exibirContaImobiliaria() {
      return (
        (this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' && this.maisFiltros) ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS' ||
        this.relatorio.nome === 'REMESSAS_GERADAS' || 
        this.relatorio.nome === 'PREVISAO_RECEBIMENTO' ||
        this.relatorio.nome === 'RECIBOS_REGISTRADOS' || 
        this.relatorio.nome === 'BOLETOS_AVULSOS'
        )
    },
    exibirAtendente() {
      return (
        this.relatorio.nome === 'DESEMPENHO_LOCACAO'
        )
    },
    exibirStatusTipoAluguel() {
      return (
        this.relatorio.nome === 'ALUGUEIS_ATRASADOS' && this.maisFiltros
        )
    },
    exibirInformacoesFiador() {
      return (
        this.relatorio.nome === 'ALUGUEIS_ATRASADOS'
        )
    },
    exibirPagamentosParciais() {
      return (
        this.relatorio.nome === 'ALUGUEIS_ATRASADOS' || this.relatorio.nome === 'ALUGUEIS_RECEBIDOS'
        )
    },
    exibirDeclaracaoIR() {
      return (
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' ||
        this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS'
        )
    },
    exibirOrdenacao() {
      return this.relatorio.nome === 'ALUGUEIS_ATRASADOS' || this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' || this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS';
    },
    exibirItemOrdenacao(){
      return this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' || this.relatorio.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS';
    },
    exibirFiltroContratos() {
      return (
        this.relatorio.nome === 'REPASSES_REALIZADOS' || this.relatorio.nome === 'PREVISAO_REPASSE' || 
        this.relatorio.nome === 'PREVISAO_RECEBIMENTO' || (this.relatorio.nome === 'ALUGUEIS_RECEBIDOS' && this.maisFiltros)
      )
    },
    exibirBotaoVisualizarItensFinanceiros(){
      return this.relatorio.nome === 'RESUMO_FINANCEIRO_REPASSE' ||
        this.relatorio.nome === 'RESUMO_FINANCEIRO_RECIBO';
    },
    // UTIL
    bancos() { 
      return BANCOS;
    },
    tipoBoleto() {
      return [
        ...TIPO_BOLETO,
        { label: 'Todos', data: 'TODOS' },
      ];
    }
  },
  watch:{
    'relatorio.itensFinanceiros': function(newValue){
      if(!newValue){
        this.relatorio.itensPagos = false;
      }
    }
  },
  methods: {
  ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisRelatoriosStore", ["gerarRelatorio", "listarUsuarios", "listarClientes", "listarProprietarios", "listarAlugueis"]),
    ...mapActions('alugueisImoveisStore', ["recuperarCondominios"]),

    onOpen() {
      this.limparFiltros();
      this.relatorio.nome = undefined;
    },

    prepararPayloadRelatorio(relatorio) {

      if(relatorio.nome === 'ALUGUEIS_RECEBIDOS' || relatorio.nome === 'PREVISAO_RECEBIMENTO'){
        relatorio = {
          ...relatorio,
          locatario: relatorio.cliente,
          cliente: undefined
        }
      }

      const payload = Object.assign({}, relatorio);
      //lista de status para uma string
      payload.statusSelecionados = payload.statusSelecionados.join(',');

      if( (payload.nome === 'REPASSES_ATRASADOS' || payload.nome === 'BOLETOS_AVULSOS' ||
      payload.nome === 'REPASSES_ATRASADOS' || payload.nome === 'PREVISAO_RECEBIMENTO' || this.relatorio.nome === 'RESUMO_FINANCEIRO_REPASSE' ||
      this.relatorio.nome === 'RESUMO_FINANCEIRO_RECIBO') && !payload.filtroCliente) {
        delete payload.cliente 
        delete payload.locatario

        if(payload.nome !== 'PREVISAO_RECEBIMENTO'){
          delete payload.proprietario
        }        
      }

      if((payload.nome === 'PREVISAO_REPASSE' || payload.nome === 'PREVISAO_RECEBIMENTO') && !payload.filtroProprietario) { 
        delete payload.proprietario  
      }

      if( payload.nome === 'REPASSES_REALIZADOS' && payload.dataBaixaRepasse === 'DATA_BAIXA' ) {
        payload.dataBaixaInicial = payload.dataInicial;
        payload.dataBaixaFinal = payload.dataFinal;
        delete payload.dataInicial;
        delete payload.dataFinal;
      }
      if( payload.nome === 'REPASSES_REALIZADOS' && payload.formaPagamentoRepasse !== 'DEPOSITO_EM_CONTA' ) { 
        delete payload.bancoRepasse 
      }
      
      if( payload.nome === 'ALUGUEIS_RECEBIDOS' || payload.nome === 'ALUGUEIS_RECEBIDOS_ENCARGOS' ) { 
        if(payload.dataBaixaRepasse === 'DATA_BAIXA') {
          payload.dataBaixaInicial = payload.dataInicial;
          payload.dataBaixaFinal = payload.dataFinal;

          delete payload.dataInicial;
          delete payload.dataFinal;
        }
        if(payload.dataBaixaRepasse === 'DATA_CREDITO') {
          payload.dataCreditoInicial = payload.dataInicial;
          payload.dataCreditoFinal = payload.dataFinal;

          delete payload.dataInicial;
          delete payload.dataFinal;
        }
        if(payload.dataBaixaRepasse === 'DATA_VENCIMENTO') {
          payload.dataVencimentoInicial = payload.dataInicial;
          payload.dataVencimentoFinal = payload.dataFinal;

          delete payload.dataInicial;
          delete payload.dataFinal;
        }
      }

      if(payload.nome === 'ALUGUEIS_ATRASADOS') {
        if(payload.tipoAluguel !== 'TODOS') {
          payload.aluguel = {tipoAluguel: payload.tipoAluguel};
          delete payload.tipoAluguel;
        }
      } else {
        delete payload.aluguel;
      }

      if(this.exibirFiltroContratos && this.relatorio.aluguel) {
        payload.aluguel = {
          id: this.relatorio.aluguel.id,
          idNaImobiliaria: this.relatorio.aluguel.idNaImobiliaria,
        }
      }

      if( payload.formaPagamentoRepasse === 'TODOS' ) { delete payload.formaPagamentoRepasse }
      if( payload.declaracaoIR === 'TODOS' ) { delete payload.declaracaoIR }
      if( payload.tipoAluguel === 'TODOS' ) { delete payload.tipoAluguel }

      if(payload.nome != 'RESUMO_FINANCEIRO_REPASSE' && payload.nome != 'RESUMO_FINANCEIRO_RECIBO'){
        delete payload.itensFinanceiros;
        delete payload.itensPagos
      }else if(this.relatorio.itensFinanceiros){
        if(payload.nome === 'RESUMO_FINANCEIRO_REPASSE'){
          payload.nome = 'RESUMO_FINANCEIRO_REPASSE_ITENS'
        }else{
          payload.nome = 'RESUMO_FINANCEIRO_RECIBO_ITENS'
        }
      }

      //delete de itens para filtros
      delete payload.filtroCliente;
      delete payload.filtroProprietario;
      delete payload.filtroContrato;
      delete payload.filtroBanco;
      delete payload.filtroLocatario;
      delete payload.filtroConta;
      delete payload.filtroCondominio;
      delete payload.filtroAtendente;
      return payload;
    },

    periodoDataNaoEValido() {
      const dataInicialIsValida = funcoes.validarData(this.relatorio.dataInicial);
      const dataFinalIsValida = funcoes.validarData(this.relatorio.dataFinal);

      return !(dataInicialIsValida && dataFinalIsValida);
    },

    gerarRelatorioHandler() {
      
      if(!this.validarRangeData() && (this.relatorio.nome === 'RESUMO_FINANCEIRO_REPASSE' || this.relatorio.nome === 'RESUMO_FINANCEIRO_RECIBO')) {
        this.exibirAlert('Atenção', 'Para melhor geração dos dados, pesquise por datas dentro de um período de 1 mês!')
        return
      }

      if(this.relatorio.nome === 'PREVISAO_RECEBIMENTO') {
        if(this.periodoDataNaoEValido()) {
          this.$message.warning('Selecione um Período válido');
          return;
        }
      }

      if(this.relatorio.nome === 'REPASSES_REALIZADOS') {
        if(this.periodoDataNaoEValido()) {
          this.$message.warning('Selecione um Período válido');
          return;
        }
      }

      if(this.relatorio.nome === 'REPASSES_EFETIVADOS_POR_PERIODO') {
        if(this.periodoDataNaoEValido()) {
          this.$message.warning('Selecione um Período válido');
          return;
        }

        if(this.relatorio.proprietario === undefined || this.relatorio.proprietario === null) {
          this.$message.warning('Selecione um Proprietário');
          return;
        }
      }

      if(this.relatorio.nome === 'BOLETOS_AVULSOS') {
        if(this.periodoDataNaoEValido()) {
          this.$message.warning('Selecione um Período válido');
          return;
        }
      }

      if(this.relatorio.nome === 'REMESSAS_GERADAS') {
        const dataRemessaNaoEValida = !funcoes.validarData(this.relatorio.dataInicial);
        
        if(dataRemessaNaoEValida) {
          this.$message.warning('Selecione uma data válida');
          return;
        }
      }

      if(this.relatorio.nome === 'DESEMPENHO_LOCACAO') {
        if(this.periodoDataNaoEValido()) {
          this.$message.warning('Selecione um Período válido');
          return;
        }
      }

      if(this.relatorio.nome === 'RESUMO_CARTEIRA') {
        if(this.periodoDataNaoEValido()) {
          this.$message.warning('Selecione um Período válido');
          return;
        }
      }
      if(this.relatorio.nome === 'RECIBOS_REGISTRADOS') {
        if(!this.relatorio.contaBancaria.nome) {
          this.$message.warning('Selecion uma conta bancaria da imobiliaria.');
          return;
        }
      }

      this.gerar();
    },

    gerar() {
      const payload = this.prepararPayloadRelatorio(this.relatorio);

      this.showLoading();
      this.gerarRelatorio(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case 'SUCESSO':
              window.open(resultado.mensagem, "_blank");
              break;
            case 'FALHA':
              this.$message.warning('Não foi possível gerar o relatório');
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },

    // DIALOGS
    exibirSelecionarContaImobiliariaDialog() {
      this.visibilidadeSelecionarContaImobiliariaDialog = true;
    },
    fecharSelecionarContaImobiliariaDialog(contaBancaria) {
      this.relatorio.contaBancaria = contaBancaria
      this.visibilidadeSelecionarContaImobiliariaDialog = false;
    },

    // SELECTS - DROPDOWNS
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        })
        .catch(() => {
          this.loadingUsuarios = false;
        });
    },
    filtrarProprietariosSelect(queryString) {
      let payload = { categoriaPesquisa: 'PROPRIETARIO' };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingProprietario = true;
      this.listarProprietarios(payload)
        .then(() => {
          this.loadingProprietario = false;
        })
        .catch(() => {
          this.loadingProprietario = false;
        });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      })
    },
    recuperarCondominiosSelect(queryString) {
      let payload = { nome: queryString };
      
      this.loadingCondominios = true;
      this.recuperarCondominios(payload)
      .then((resultado) => {
        this.condominiosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
        this.loadingCondominios = false;
      });
    },
    recuperarCidadesSelect(queryString) {
      if(this.relatorio.imovel.estado.id == 0) {
        this.$message.warning("Selecione o estado");
        return;
      }
      let payload = { nome: queryString, estado: { id: this.relatorio.imovel.estado.id } };
      
      this.loadingCidades = true;
      this.listarCidades(payload)
      .then((resultado) => {
        this.loadingCidades = false;
        this.cidadesDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingCidades = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    recuperarBairrosSelect(queryString) {
      if(this.relatorio.imovel.cidade.id == 0) {
        this.$message.warning("Selecione a cidade");
        return;
      }
      let payload = { nome: queryString, cidade: { id: this.relatorio.imovel.cidade.id } };

      this.loadingBairros = true;
      this.listarBairros(payload)
      .then((resultado) => {
        this.loadingBairros = false;
        this.bairrosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingBairros = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    recuperarContratosSelect(queryString) {
      let payload = { idNaImobiliaria: queryString };
      this.loadingContratos = true;
      this.listarAlugueis(payload)
      .then((resultado) => {
        this.loadingContratos = false;
        this.listaContratos = resultado.lista;
      }).catch(() => {
        this.loadingContratos = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    // UTILS
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    limparFiltros() {
      this.relatorio = {
        nome: this.relatorio.nome,
        cliente: undefined,
        usuario: undefined,
        contaBancaria: { nome: undefined },
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        exibirPagamentosParciais: false,
        formaPagamentoRepasse: 'TODOS',
        tipoAluguel: 'TODOS',
        tipoBaixa: 'TODOS',
        filtroCliente:  false,
        filtroProprietario: false,
        filtroContrato: false,
        filtroBanco: false,
        filtroConta: false,
        filtroLocatario: false,
        filtroCondominio: false,
        filtroAtendente: false,
        dataBaixaRepasse: 'DATA_PAGAMENTO',
        declaracaoIR: 'TODOS',
        statusBoletoAvulso: 'TODOS',
        statusSelecionados: ['APROVADO'],
        ordenacao: 'CLIENTE',
        tipoBoleto: 'TODOS',
        xls: false,
        itensFinanceiros: false,
        itensPagos: false
      }
      this.maisFiltros = false;
    },
    fechar() {
      this.$emit('close');
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    validarRangeData() {
      if(this.relatorio.dataInicial && this.relatorio.dataFinal){
        const inicio = funcoes.stringParaData(this.relatorio.dataInicial);
        const fim = funcoes.stringParaData(this.relatorio.dataFinal);

        if (funcoes.diffMeses(inicio, fim, false) === 0) {
          return true;
        }      
      }
      return false;
    },
    expandirFiltros(){
      this.maisFiltros = !this.maisFiltros;
    }
  }
}
</script>

<style scoped>
.form-item {
    width: 100%; 
}
.field-margin{
  margin-top: 5px;
}
.select {
  font-size: 50%;
}
.expand-button{
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  color: #008080;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  padding: 4px 0px;
}
.arrow{
  transition: transform 0.2s;
  font-size: 12px;
}
.arrow.rotated{
  transform: rotate(180deg)
}
.expand-section{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2px 0px;
  padding-top: 1px;
  border-top: 1px solid #e5e7eb;
}
.section-vertical{
  justify-content: left;
  padding-right: 10px;
  border-right: 2px solid #e5e7eb;
}
.el-checkbox{
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.selecionar-conta >>> .el-input__inner{
  cursor: pointer;
}
.filtros-radio{
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 4px 16px;
  align-items: center;
}
</style>